module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.locationsCount > 0) ? _c('div', [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("LOCATION PREFERENCE")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row no-gutter"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row no-gutter"
  }, [_c('label', {
    staticClass: "col-sm-6 control-label",
    attrs: {
      "for": "line1"
    }
  }, [_vm._v("Select a preferred location for your brick:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prefLocation),
      expression: "prefLocation"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.prefLocation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.onChange(_vm.prefLocation)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Please select a location --")]), _vm._v(" "), _vm._l((_vm.locationsList), function(loc, locIndex) {
    return _c('option', {
      domProps: {
        "value": locIndex
      }
    }, [_vm._v("\n                            " + _vm._s(loc) + "\n                        ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('a', {
    staticClass: "map-link pointer",
    on: {
      "click": _vm.showPaverLocations
    }
  }, [_c('svg', {
    staticStyle: {
      "stroke-width": "0px",
      "width": "50px",
      "height": "50px"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "4.4015069007873535 25.49999237060547 191.19700622558594 149.10000610351562",
      "role": "img",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M47.5 174.3h.1c.3.2.7.3 1.1.3.2 0 .4 0 .6-.1l50.7-13.8 50.7 13.8c.2.1.4.1.6.1.4 0 .7-.1 1.1-.3h.1l42-25.6c.9-.5 1.3-1.6 1-2.6l-23.2-81.6c-.2-.7-.7-1.2-1.4-1.5-.7-.3-1.4-.2-2 .1l-23.1 13c-1.1.6-1.5 2.1-.9 3.2s2 1.5 3.2.9l20.6-11.5 22 77.1-37.4 22.8-8.9-71c-.2-1.3-1.4-2.2-2.6-2-1.3.2-2.2 1.3-2 2.6l8.7 71.2-46.5-12.9v-12.7c0-1.3-.7-2.3-2-2.3s-2 1-2 2.3v12.7l-46.4 12.6L60.4 98c.2-1.3-.8-2.4-2.1-2.6-1.3-.1-2.5.7-2.6 2l-8.9 71-37.3-22.8 21.9-77.1L52 80c1.1.6 2.5.2 3.2-.9.6-1.1.2-2.5-.9-3.2L31.1 63c-.6-.3-1.4-.4-2-.1-.7.3-1.2.8-1.4 1.5L4.5 146c-.3 1 .1 2.1 1 2.6l42 25.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M98.4 134.4c.4.4 1 .6 1.6.6.6 0 1.1-.2 1.6-.6 1.6-1.4 38.1-34.9 38.1-69.3 0-22.2-17.4-39.6-39.6-39.6S60.4 42.8 60.4 65c0 33.9 36.5 67.9 38 69.4zM100 30c19.9 0 35 15 35 35 0 28.4-27.9 57.5-35 64.4C93 122.5 65 93 65 65c0-19.9 15.1-35 35-35z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M121 65c0-11.6-9.4-21-21-21s-21 9.4-21 21 9.4 21 21 21 21-9.4 21-21zm-21 16.3c-9 0-16.3-7.3-16.3-16.3S91 48.7 100 48.7 116.3 56 116.3 65 109 81.3 100 81.3z"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("View Map")])])])]), _vm._v(" "), _c('paver-locations-popup', {
    attrs: {
      "modal-id": "paverLocationsPopup"
    }
  }, [_c('template', {
    slot: "header"
  }, [_vm._v("Location Preference Map")]), _vm._v(" "), _vm._t("default", [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "modal-img-wrap"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "alt": "map",
      "src": _vm.locationsMapImage
    }
  })])])])], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29cef641","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/preferred-location.vue
// module id = 6tue
// module chunks = 1